var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 48 48",
    height: "48px",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expanded"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,40H4c-2.206,0-4-1.794-4-4V6c0-2.206,1.794-4,4-4h40c2.206,0,4,1.794,4,4v30C48,38.206,46.206,40,44,40z M4,4     C2.897,4,2,4.897,2,6v30c0,1.103,0.897,2,2,2h40c1.103,0,2-0.897,2-2V6c0-1.103-0.897-2-2-2H4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38,46H10c-0.552,0-1-0.448-1-1s0.448-1,1-1h28c0.552,0,1,0.448,1,1S38.552,46,38,46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.02,46c-0.007,0-0.013,0-0.02,0H17c-0.321,0-0.623-0.154-0.811-0.416c-0.188-0.261-0.239-0.596-0.138-0.901l2-6     C18.188,38.275,18.569,38,19,38h10c0.431,0,0.812,0.275,0.949,0.684l1.94,5.821C31.972,44.651,32.02,44.82,32.02,45     C32.02,45.552,31.572,46,31.02,46z M18.387,44h11.226l-1.333-4h-8.559L18.387,44z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44,32H4V6h40V32z M6,30h36V8H6V30z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 35,
    r: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.d286dc6dae5225d9f73d68012d14c776.svg";
export { ForwardRef as ReactComponent };